@if (address) {
  @if (mode === 'strip') {
    @if (hasAddress) {
      <div class="intake-strip">
        <nb-icon icon="email-outline"></nb-icon>
        <span class="label hint-tip" tabindex="0" [nbTooltip]="'intake.address.strip_retention' | translate: { days: address.retention_days }" [attr.aria-description]="'intake.address.strip_retention' | translate: { days: address.retention_days }">{{ 'intake.address.strip_label' | translate }}</span>
        <span class="address"><span>{{ address.address }}</span><bst-intake-copy [text]="address.address"></bst-intake-copy></span>
      </div>
    }
  } @else {
    <ul class="field-list">
      <li class="top addr">
        <label><nb-icon icon="email-outline"></nb-icon><span>{{ 'intake.address.label' | translate }}</span></label>
        <div class="value">
          <span class="address-row">
            @if (hasAddress) {
              <bst-copiable [link]="false" [text]="address.address"></bst-copiable>
              @if (canRotate) {
                <button nbButton size="small" status="danger" ghost [disabled]="busy" (click)="rotate()">
                  <nb-icon icon="refresh-outline"></nb-icon><span>{{ 'intake.address.rotate' | translate }}</span>
                </button>
              }
            } @else {
              <span class="muted">{{ 'intake.address.none_yet' | translate }}</span>
              @if (canRotate) {
                <button nbButton size="small" status="primary" [disabled]="busy" (click)="rotate()">
                  <nb-icon icon="plus-outline"></nb-icon><span>{{ 'intake.address.create' | translate }}</span>
                </button>
              }
            }
          </span>
          <!-- Without an address there is nothing to keep private yet. -->
          @if (hasAddress) { <span class="note">{{ 'intake.address.private_hint' | translate }}</span> }
        </div>
      </li>
      @if (hasAddress) {
        <li class="top">
          <label><nb-icon icon="corner-up-right-outline"></nb-icon><span>{{ 'intake.address.forwarding' | translate }}</span></label>
          <div class="value howto">
            <div>
              <span class="provider">{{ 'intake.address.gmail_title' | translate }}</span>
              <ol>
                <li>{{ 'intake.address.gmail_1' | translate }}</li>
                <li>{{ 'intake.address.gmail_2' | translate }}</li>
                <li>{{ 'intake.address.gmail_3' | translate }}</li>
              </ol>
            </div>
            <div>
              <span class="provider">{{ 'intake.address.m365_title' | translate }}</span>
              <ol>
                <li>{{ 'intake.address.m365_1' | translate }}</li>
                <li>{{ 'intake.address.m365_2' | translate }}</li>
                <li>{{ 'intake.address.m365_3' | translate }}</li>
              </ol>
              <span class="note">{{ 'intake.address.m365_note' | translate }}</span>
            </div>
          </div>
        </li>
      }
      <li class="top">
        <label><nb-icon icon="options-2-outline"></nb-icon><span>{{ 'intake.address.limits_title' | translate }}</span></label>
        <ul class="value limits">
          <li>{{ 'intake.address.limit_attachments' | translate }}</li>
          <li>{{ 'intake.address.limit_monthly' | translate: { cap: address.monthly_cap } }}</li>
          <li>{{ 'intake.address.limit_retention' | translate: { days: address.retention_days } }}</li>
        </ul>
      </li>
    </ul>
  }
}
